// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"ba1b1d7c","977":"cdd3cb44"}[chunkId] + ".chunk.js";
};